module.exports = __webpack_public_path__ + "img/logo--dark.4869b819.png";